export class TreasuryTransactionPaymentSourceDetail {
  code?: string;
  amount?: number;
  intervalAmount?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
}

export class TreasuryTransferSummaryResponseDto {
  businessEntityId: number;
  amount?: number;
  intervalAmount?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
  isRefund?: boolean;
  transactionTypeDetails?: TreasuryTransactionPaymentSourceDetail[];
}
